/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Santai_OkInputs */

const en_tut_santai_ok = /** @type {(inputs: Tut_Santai_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaction animations appear on the map for everyone in the same room, and the game board looks identical to every player.`)
};

const id_tut_santai_ok = /** @type {(inputs: Tut_Santai_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animasi reaksi muncul di peta untuk semua yang berada di ruang yang sama, dan papan permainan terlihat sama bagi semua pemain.`)
};

/**
* | output |
* | --- |
* | "Reaction animations appear on the map for everyone in the same room, and the game board looks identical to every player." |
*
* @param {Tut_Santai_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_santai_ok = /** @type {((inputs?: Tut_Santai_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Santai_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_santai_ok(inputs)
	return en_tut_santai_ok(inputs)
});